var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.sign-up-modal",modifiers:{"sign-up-modal":true}}],staticClass:"help-btn",style:({width: _vm.width})},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }